export default "__VITE_ASSET__BX_7TltM__"